module.exports = __webpack_public_path__ + "img/imds.874b33bd.png";